import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/context/AuthContext';

import { AuthSkeleton } from './Skeleton';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="to-primary-50/10 flex min-h-screen items-center justify-center bg-gradient-to-br from-white via-neutral-50/20 dark:from-neutral-950 dark:via-neutral-950 dark:to-neutral-900/30">
        <AuthSkeleton />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
